import Component from "./component";
import { generateClassName } from "./utils";
import { registerComponent } from "./jquery";
import { mmList, mmListOptions } from "@/types";

class List extends Component<mmListOptions> implements mmList {
  private _dxList!: DevExpress.ui.dxList;

  constructor(element: HTMLElement, options?: mmListOptions) {
    super(element, options);

    this._dxList = ($(this._element) as any)

      .dxList({
        dataSource: this._options.dataSource,
        displayExpr: "applicationName",
        itemTemplate: this._options.itemTemplate,
        searchEnabled: this._options.searchEnabled,
        searchExpr: this._options.searchExpr,
        noDataText: this._options.noDataText,
        onItemClick: this._options.onItemClick,
        onContentReady: this._options.onContentReady,
        indicateLoading: this._options.indicateLoading,
        elementAttr: {
          class: generateClassName("list", this._options.color!, this._options.size!, this._options.className),
          ...(this._options.attributes ?? {}),
        },

        // accessKey: this._options.accessKey,
        // activeStateEnabled: this._options.activeStateEnabled,
        allowItemDeleting: this._options.allowItemDeleting,
        // bounceEnabled: this._options.bounceEnabled,
        // collapsibleGroups: this._options.collapsibleGroups,
        // dataSource: this._options.dataSource,
        // disabled: this._options.disabled,
        // displayExpr: this._options.displayExpr,
        focusStateEnabled: this._options.focusStateEnabled,
        // groupComponent: this._options.groupComponent,
        // grouped: this._options.grouped,
        // groupRender: this._options.groupRender,
        // groupTemplate: this._options.groupTemplate,
         height: this._options.height,
        // hint: this._options.hint,
        // hoverStateEnabled: this._options.hoverStateEnabled,
        // indicateLoading: this._options.indicateLoading,
        // itemComponent: this._options.itemComponent,
        itemDeleteMode: this._options.itemDeleteMode,
        // itemDragging: this._options.itemDragging,
        // itemHoldTimeout: this._options.itemHoldTimeout,
        // itemRender: this._options.itemRender,
        // itemTemplate: this._options.itemTemplate,
        // keyExpr: this._options.keyExpr,
        // menuItems: this._options.menuItems,
        // menuMode: this._options.menuMode,
        // nextButtonText: this._options.nextButtonText,
        // noDataText: this._options.noDataText,
        // onContentReady: this._options.onContentReady,
        // onDisposing: this._options.onDisposing,
        // onGroupRendered: this._options.onGroupRendered,
        // onInitialized: this._options.onInitialized,
        // onItemClick: this._options.onItemClick,
        // onItemContextMenu: this._options.onItemContextMenu,
        // onItemDeleted: this._options.onItemDeleted,
        // onItemDeleting: this._options.onItemDeleting,
        // onItemHold: this._options.onItemHold,
         onItemRendered: this._options.onItemRendered,
        // onItemReordered: this._options.onItemReordered,
        // onItemSwipe: this._options.onItemSwipe,
        // onOptionChanged: this._options.onOptionChanged,
        // onPageLoading: this._options.onPageLoading,
        // onPullRefresh: this._options.onPullRefresh,
        // onScroll: this._options.onScroll,
        // onSelectAllValueChanged: this._options.onSelectAllValueChanged,
        // onSelectionChanged: this._options.onSelectionChanged,
        // onSelectionChanging: this._options.onSelectionChanging,
        // pageLoadingText: this._options.pageLoadingText,
         pageLoadMode: this._options.pageLoadMode,
        // pulledDownText: this._options.pulledDownText,
        // pullingDownText: this._options.pullingDownText,
        // pullRefreshEnabled: this._options.pullRefreshEnabled,
        // refreshingText: this._options.refreshingText,
        // repaintChangesOnly: this._options.repaintChangesOnly,
        // rtlEnabled: this._options.rtlEnabled,
        // scrollByContent: this._options.scrollByContent,
        // scrollByThumb: this._options.scrollByThumb,
        // scrollingEnabled: this._options.scrollingEnabled,
        // searchEditorOptions: this._options.searchEditorOptions,
        // searchEnabled: this._options.searchEnabled,
        // searchExpr: this._options.searchExpr,
        // searchMode: this._options.searchMode,
        // searchTimeout: this._options.searchTimeout,
        // searchValue: this._options.searchValue,
        // selectAllMode: this._options.selectAllMode,
        // selectAllText: this._options.selectAllText,
        // selectByClick: this._options.selectByClick,
        // selectedItemKeys: this._options.selectedItemKeys,
        // selectedItems: this._options.selectedItems,
        // selectionMode: this._options.selectionMode,
        // showScrollbar: this._options.showScrollbar,
        // showSelectionControls: this._options.showSelectionControls,
        // tabIndex: this._options.tabIndex,
        // useNativeScrolling: this._options.useNativeScrolling,
        // visible: this._options.visible,
        width: this._options.width,
      })
      .dxList("instance");
  }

  public get value(): string | number | Date {
    const selectedItems = this._dxList.option("selectedItems");
    if (Array.isArray(selectedItems) && selectedItems.length > 0) {
      return selectedItems[0];
    }
    return "";
  }

  public set value(val: string | number | Date) {
    this._dxList.option("selectedItems", val !== undefined ? [val] : []);
  }

  public get readOnly(): boolean {
    return this._dxList.option("disabled") ?? false;
  }

  public set readOnly(val: boolean) {
    this._dxList.option("disabled", val);
  }

  public get disabled(): boolean {
    return this._dxList.option("disabled") ?? false;
  }

  public set disabled(val: boolean) {
    this._dxList.option("disabled", val);
  }

  public get isEmpty(): boolean {
    const val = this._dxList.option("selectedItems");
    return !val || val.length === 0;
  }

  public set isEmpty(val: boolean) {
    if (val) {
      this._dxList.option("selectedItems", []);
    }
  }

  public getDefaults(): Partial<mmListOptions> {
    return {
      color: "default",
      size: "md",
      visible: true,
      rtlEnabled: false,
    };
  }
}

registerComponent("mmList", List);

export default List;
